import { createChildPath } from '../../../utils';
import generateAsyncRouteComponent from '../../../generateAsyncRouteComponent';

export default {
  path: createChildPath('start-return'),
  component: generateAsyncRouteComponent({
    loader: () => import('./containers/StartReturnPageContainer'),
  }),
};
